Controller = App.loadClass 'core::Angular/Controller'

class exports.DuplicateFieldsController extends Controller

    constructor: (@scope, @transitions, @repo) ->
        super(@scope, @transitions)

        @scope.step.title = 'Duplicate Fields'
        @scope.step.previous = @previous
        @scope.step.next = @next
        @scope.step.includeDuplicates = @includeDuplicates
        @scope.step.canContinue = -> true # nothing to prevent continuing here

        # stuff for duplicate fields (we're just using the global `@scope.
        # selected.duplicate_fields` array and aliasing it for ease of access)
        @scope.placeholder = 'Loading duplicate fields...'
        @scope.duplicate_fields = @scope.selected.duplicate_fields

        # load data
        @loadDuplicateFields()

    loadDuplicateFields: () =>
        @repo.getDuplicateFields(@scope.selected.survey_results).then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.$parent.setAlert(result.data.status)
                else
                    @scope.$parent.setAlert
                        type: 'error'
                        msg: 'Failed to load duplicate fields'
                return

            duplicate_fields = result.data.data.duplicate_fields
            if duplicate_fields.length is 0
                @scope.placeholder = 'No duplicate fields found'

            @sanityCheck(duplicate_fields)

        , () =>
            # if the request failed
            @scope.$parent.setAlert
                type: 'error'
                msg: 'Failed to load duplicate fields'

    sanityCheck: (duplicate_fields) =>
        # Since this step is just referencing the underlying array, this is a
        # bit different from the other sanityCheck() functions. First make
        # absolutely sure we don't have duplicate fields that aren't actually
        # duplicate fields (reverse for loop because we're deleting things).
        for field, i in @scope.duplicate_fields by -1
            j = _.findIndex(duplicate_fields, { id: field.id })
            if j is -1
            else
                # make sure we don't have any invalid years either
                new_field = duplicate_fields[j]
                for year, arr of field.survey_results
                    if parseInt(year) not in new_field.years
                        delete field.survey_results[year]

        # And then add any duplicate fields that weren't in the array before.
        # The reason we're doing this instead of overwriting the array is to
        # preserve the user's selections (if they went forward and then back).
        for field, i in duplicate_fields
            j = _.findIndex(@scope.duplicate_fields, { id: field.id })
            if j is -1
                # Go ahead and initialize the survey_results array to store the selected results
                # (resolving duplicates) by year.
                # I'm using an object instead of an array here because,
                # although it's numerically indexed (using years), it's not a
                # "normal" array, because the indexes may not be sequential and
                # don't start with 0.
                field.survey_results = {}
                for year in field.years
                    field.survey_results[year] = []

                # use splice to maintain the order (we're assuming the back-end
                # is giving us an already-sorted list)
                @scope.duplicate_fields.splice(i, 0, field)

            else
                # update the existing field to make sure we have all the years
                existing_field = @scope.duplicate_fields[j]
                for year in field.years
                    existing_field.survey_results[year] ?= []

    previous: () =>
        @scope.$parent.clearAlert()
        @scope.goToStep('select_surveys')

    next: () =>
        @scope.$parent.clearAlert()

        @scope.goToStep('farm_field')

    includeDuplicates: () =>
        @scope.$parent.clearAlert()

        # clear the survey result selections so duplicates are still duplicates
        for field in @scope.duplicate_fields
            for year, arr of field.survey_results
                field.survey_results[year] = []

        @scope.goToStep('download')
